"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactBeautifulDnd = require("react-beautiful-dnd");
var _IconRearrange = _interopRequireDefault(require("../../../icons/General/IconRearrange"));
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const DraggableRow = ({
  id,
  index,
  children,
  subContent,
  disableDrag = false
}) => /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactBeautifulDnd.Draggable, {
  draggableId: id,
  index: index,
  isDragDisabled: disableDrag,
  children: provided => /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.DraggableWrapper, {
    className: "table-dragable",
    ref: provided.innerRef,
    ...provided.dragHandleProps,
    ...provided.draggableProps,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.RowWrapper, {
      className: "table-dragrow",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.DragIcon, {
        children: !disableDrag && /*#__PURE__*/(0, _jsxRuntime.jsx)(_IconRearrange.default, {
          size: "14px"
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.ContentWrapper, {
        children: children
      })]
    }), subContent && /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.ExtraWrapper, {
      children: subContent
    })]
  })
}, id);
var _default = exports.default = DraggableRow;